import { createFileRoute } from '@tanstack/react-router';
import { privateCacheHeaders } from '@/analytics/cache-headers';
import { useEffect, useState } from 'react';
import { Schema } from 'effect';
import { authClient } from '@/lib/auth-client';

const searchSchema = Schema.Struct({
  provider: Schema.Literals(['google', 'apple']),
  extensionId: Schema.String,
});

export const Route = createFileRoute('/_marketing/browserExtAuth')({
  // Auth surface — never shared-cached, whatever the layout default is.
  headers: privateCacheHeaders(),
  validateSearch: Schema.toStandardSchemaV1(searchSchema),
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: Page,
});

function Page() {
  const { provider, extensionId } = Route.useSearch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void authClient.signIn
      .social({
        provider,
        callbackURL: `/browserExtAuthCallback?extensionId=${extensionId}`,
      })
      .catch((error: unknown) => {
        setError(error instanceof Error ? error.message : String(error));
      });
  }, [provider, extensionId]);

  if (error) {
    return <p className='p-4 text-red-600'>Could not start sign-in: {error}</p>;
  }

  return <p className='p-4'>Redirecting to sign-in…</p>;
}
